/**
 * Content with TOC - Frontend JavaScript
 *
 * Handles the mobile dropdown toggle for the table of contents.
 */

( function () {
	'use strict';

	const BREAKPOINT_LG = 992;

	function initTocToggle() {
		const toggleButtons = document.querySelectorAll(
			'.content-with-toc__toggle'
		);

		toggleButtons.forEach( ( button ) => {
			const listId = button.getAttribute( 'aria-controls' );
			const list = document.getElementById( listId );

			if ( ! list ) {
				return;
			}

			// Handle toggle click
			button.addEventListener( 'click', () => {
				const isExpanded =
					button.getAttribute( 'aria-expanded' ) === 'true';
				button.setAttribute( 'aria-expanded', ! isExpanded );
			} );

			// Close dropdown when clicking a link (mobile)
			list.querySelectorAll( 'a' ).forEach( ( link ) => {
				link.addEventListener( 'click', () => {
					if ( window.innerWidth < BREAKPOINT_LG ) {
						button.setAttribute( 'aria-expanded', 'false' );
					}
				} );
			} );

			// Handle resize - reset state when crossing breakpoint
			let wasDesktop = window.innerWidth >= BREAKPOINT_LG;

			window.addEventListener( 'resize', () => {
				const isDesktop = window.innerWidth >= BREAKPOINT_LG;

				if ( isDesktop !== wasDesktop ) {
					// Reset to collapsed when switching to mobile
					if ( ! isDesktop ) {
						button.setAttribute( 'aria-expanded', 'false' );
					}
					wasDesktop = isDesktop;
				}
			} );
		} );
	}

	// Initialize when DOM is ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initTocToggle );
	} else {
		initTocToggle();
	}
} )();
